// The Product Line Reclassification guide (26_ProductLine.jsx · ModuleHelp, Max 01/11).
const en = {
  statsT: 'Where the reclassification stands',
  statsB: 'Counts of materials already mapped, waiting for a decision, without a rule yet, plus the number of rules and tagged SKUs. Refresh above them reloads everything.',
  tabsT: 'Four tabs',
  tabsB: 'Ready to use lists the settled codes; Open questions is for the Product Line team; No rule yet lists codes nobody has ruled on; Rules holds the rules behind them.',
  toolbarT: 'Search and narrow down',
  toolbarB: 'Search any text, show only untagged SKUs, or export the list to Excel. Clear resets sorting and filters.',
  tableT: 'The materials',
  tableB: 'The whole list scrolls in this box with the header frozen. Sort and filter each column like in Excel; where you may edit, change the line or brand on a row.',
};
const ko = {
  statsT: '재분류 진행 현황',
  statsB: '이미 매핑된 자재, 결정 대기, 규칙 없음의 건수와 규칙 수, 태그된 SKU 수입니다. 위의 새로고침을 누르면 모두 다시 불러옵니다.',
  tabsT: '네 개의 탭',
  tabsB: '사용 가능은 확정된 코드, 미결 질문은 Product Line 팀용, 규칙 없음은 아직 규칙이 없는 코드, 규칙은 그 뒤의 규칙 목록입니다.',
  toolbarT: '검색과 좁혀 보기',
  toolbarB: '텍스트로 검색하거나, 태그 없는 SKU만 보거나, 목록을 Excel로 내보낼 수 있습니다. 초기화는 정렬과 필터를 되돌립니다.',
  tableT: '자재 목록',
  tableB: '전체 목록이 이 상자 안에서 스크롤되고 머리글은 고정됩니다. 열마다 Excel처럼 정렬·필터할 수 있고, 편집 권한이 있으면 행의 라인이나 브랜드를 바꿀 수 있습니다.',
};
const vi = {
  statsT: 'Tiến độ phân loại lại',
  statsB: 'Số vật tư đã ánh xạ, đang chờ quyết định, chưa có rule, cùng số rule và số SKU đã gắn tag. Nút làm mới phía trên tải lại tất cả.',
  tabsT: 'Bốn tab',
  tabsB: 'Ready liệt kê các mã đã chốt; Open questions dành cho team Product Line; No rule yet là mã chưa ai quyết; Rules giữ các rule đứng sau chúng.',
  toolbarT: 'Tìm và thu hẹp',
  toolbarB: 'Tìm theo chữ bất kỳ, chỉ xem SKU chưa gắn tag, hoặc xuất danh sách ra Excel. Nút xóa bộ lọc đưa sắp xếp và lọc về mặc định.',
  tableT: 'Danh sách vật tư',
  tableB: 'Cả danh sách cuộn trong khung này, tiêu đề cố định. Sắp xếp và lọc từng cột như Excel; nếu có quyền sửa, bạn đổi được line hoặc brand trên từng dòng.',
};
const zh = {
  statsT: '重新分类进度',
  statsB: '已映射、待决定、尚无规则的物料数量，以及规则数和已打标签的 SKU 数。上方的刷新按钮会重新加载全部内容。',
  tabsT: '四个标签页',
  tabsB: 'Ready 列出已确定的代码；Open questions 供 Product Line 团队处理；No rule yet 是还没有规则的代码；Rules 是背后的规则。',
  toolbarT: '搜索与缩小范围',
  toolbarB: '可按任意文字搜索、只看未打标签的 SKU，或把列表导出为 Excel。清除会重置排序和筛选。',
  tableT: '物料列表',
  tableB: '整个列表在此框内滚动，表头固定。每一列都可像 Excel 一样排序和筛选；有编辑权限时可修改某行的 line 或 brand。',
};
const dictionary = { ns: 'tourProductLine', en, ko, vi, zh };
export default dictionary;
